import React, { useEffect, useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Button, FormControl } from '@mui/material';
import { IconArrowRight, IconDate } from '../../../../icons/Icon';
import styles from './filterdata.module.scss';
import { DatePicker } from '@mui/x-date-pickers';
import { useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../store/store';
// import MultiSelectNew from '../../../../components/MultiSelectNew';
import { format,differenceInDays,formatISO, parseISO ,set} from 'date-fns';
import { fetchFromDish, setParams } from '../../../../services/updateProductionPlanSlice';
import { useDispatch } from 'react-redux';
import enUS from 'date-fns/locale/en-US';
import SingleSelectWithRadio from '../../../../components/commonComponent/SingleSelectWithRadio';
import axiosInstance from '../../../../api/axios';
import { BASE_URL } from '../../../../constants/apiConstants';

interface FilterData {
  handleClick: () => void;
  handleMenuChange: (value: boolean) => void;
  handleFilterChange: () => void;
}

interface CutOffDetailsResponse {
  data: {
    cutoffdays: number;
    cutofftimehh: number;
    cutofftimemm: number;
  };
}

const FilterData: React.FC<FilterData> = ({ handleClick, handleMenuChange, handleFilterChange })  => {
  const roleId = JSON.parse(localStorage.getItem('roleId') || "");
  const dispatch = useDispatch<AppDispatch>();
  const [selectDate, setSelectDate] = useState<any>(null);
  const [cutoffTime, setCutoffTime] = useState<any>()
  const [mealTimes, setMealTimes] = useState<string>("");
  const [fromDishOption, setFromDishOption] = useState<string>("");  
  const [toDishOption, setToDishOption] = useState<string>("");  
  const [reasonOption, setReasonOption] = useState<string>(""); 
  const { params, dayparts } = useSelector((state: RootState) => state.productionPlan); 
  const { dishes } = useSelector((state: RootState) => state.getCategory); 
  const { reasons, fromdishes } = useSelector((state: RootState) => state.updateProductionPlan); 
  const mealTimeOptions = dayparts?.length ? dayparts?.map((daypart: any) => { return { label: daypart?.name, value: daypart?.daypartcode, id: daypart?.id } }) : [];
  const fromDishOptions= fromdishes?.length ?  fromdishes?.map((dish: any) => { return { label: dish?.dishname, value: dish?.dishid, id: dish?.dishid } }) : []
  const toDishOptions= dishes?.length ?  dishes?.map((dish: any) => { return { label: dish?.dishname, value: dish?.dishid, id: dish?.dishid } }) : []
  const reasonsOptions = reasons?.length ? reasons?.map((reason: any) => { return { label: reason?.reasondescription, value: reason?.reasoncode, id: reason?.reasoncode } }) : []
  const selectedMealValue = (mealTimes as any)?.value ?? mealTimes;
  const selectedFromDishValue = (fromDishOption as any)?.value ?? fromDishOption;
  const selectedToDishValue = (toDishOption as any)?.value ?? toDishOption;
  const toDishFilteredOptions = toDishOptions?.filter((dish:any) => dish?.value !== selectedFromDishValue) || [];
  const canSelectMealTime = !!selectDate;
  const canSelectFromDish = canSelectMealTime && !!selectedMealValue;
  const canSelectToDish = canSelectFromDish && !!selectedFromDishValue;
  const canSelectReason = canSelectToDish && !!selectedToDishValue;
  const userId = localStorage.getItem('userid');
  const handleChange = (value: any, type: String) => {
    switch (type) {
      case 'productionDate': 
        setSelectDate(value);
        setMealTimes("");
        setFromDishOption("");
        setToDishOption("");
        setReasonOption("");
        break;
      case 'mealOption':
        setMealTimes(value);
        setFromDishOption("");
        setToDishOption("");
        setReasonOption("");
        break;
      case 'fromDish':
        setFromDishOption(value);
      break;
      case 'toDish':
        setToDishOption(value);
      break;
      case 'reason':
        setReasonOption(value);
      break;
    }
    handleFilterChange();
  };

   // Datepicker settings
    const customEnLocale: Locale = {
      ...enUS,
      options: {
        ...enUS.options,
        weekStartsOn: 1,
      },
    };

    const GetCutOffdays = async () => {
      try {
          const roleId = Number(localStorage.getItem('roleId'));
          const payload = { modulecode: "40", roleid: roleId, sitecode: "" };
          const dateSettings = await axiosInstance.post<CutOffDetailsResponse>(
              `${BASE_URL}/api/v1/AdminConfiguration/GetCutOffDetails`,
              payload
          );
          setCutoffTime({
            days: dateSettings.data.data.cutoffdays || 1,
            hours: dateSettings.data.data.cutofftimehh || 0,
            minutes: dateSettings.data.data.cutofftimemm || 0,
          });
      } catch (error) {
          console.error("Error fetching time period:", error);
      }
  };

  const handleSubmit = () => {
     const endtime = formatISO(set(selectDate, {
      hours: cutoffTime?.hours || 24,
      minutes: cutoffTime?.minutes || 0,
      seconds: 0
     }))
  
    const isdisable = roleId !== 1 && differenceInDays(parseISO(endtime), new Date()) < cutoffTime?.days;

    const paramsPayload = {
          menudate : format(new Date(selectDate), "yyyy-MM-dd'T'00:00:00XXX"),
          userid: userId,
          daypartid: selectedMealValue,
          fromdish: selectedFromDishValue,
          todish: selectedToDishValue,
          reasonid: reasonOption,
          allsite: params?.allsite,
          siteidlist: params?.siteidlist,
          isdisable:isdisable
    }
    dispatch(setParams(paramsPayload));
    handleClick();
    handleMenuChange(false);
  };

  const isButtonDisabled = () => {
    return !selectDate || !selectedMealValue || !selectedFromDishValue || !selectedToDishValue || !reasonOption?.length;
  };
  
  useEffect(() => { 
    if(selectDate && selectedMealValue) {
      const payload = {
        menudate: format(new Date(selectDate), "yyyy-MM-dd'T'00:00:00XXX"),
        userid: userId,
        daypartid: selectedMealValue,
        allsite: params?.allsite,
        siteidlist: params?.siteidlist 
      }
      dispatch(fetchFromDish(payload))
    }
  }, [selectDate, selectedMealValue]);

  useEffect(() => {
    GetCutOffdays()
    setSelectDate(new Date(params?.menudate));
  }, [params]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}  adapterLocale={customEnLocale}>
      <FormControl fullWidth>
        <div className="flex justify-content-between align-items-end">
          <div className={`${styles.leftBox} flex justify-content-between align-items-end`}>
            <div className={`date-wrap flex flex-column mr-24 ${styles.dateWrap}`}>
              <label className={`${styles.label}`}>
                Select Production Date <span>*</span>
              </label>
              <DatePicker
                  value={selectDate}
                  onChange={(newValue) => handleChange(newValue, "productionDate")}
                  slotProps={{ field: { clearable: true } }}
                  format='dd MMM yyyy'
                  slots={{
                      openPickerIcon: IconDate,
                  }}
                  label="Select Date"
              />
            </div>
            <div className={`flex flex-column mr-24 ${styles.multiSelect}`}>
              {/* <MultiSelectNew
                options={mealTimeOptions}
                disabled={mealTimeOptions?.length==1}
                label='Select Mealtime'
                selectedValues={mealTimeOptions?.length==1? mealTimeOptions?.map((daypart: any) => daypart?.code) :mealTimes}
                onApply={(e) => handleChange(e, "mealOption")}
                showLabelOnly={true}
                placeholder='Select Mealtime'
                selectAllLabel='All Meals'
              /> */}
               <SingleSelectWithRadio
                label="Select Mealtime"
                options={mealTimeOptions}
                value={mealTimes}
                disabled={!canSelectMealTime}
                onApply={(value:any) => handleChange(value, "mealOption")}
                placeholder='Select Mealtime'
              />
            </div>
            <div className={`flex flex-column ${styles.multiSelect}`}>
              <SingleSelectWithRadio
                label="From Dish"
                options={fromDishOptions}
                value={fromDishOption}
                disabled={!canSelectFromDish}
                onApply={(value:any) => handleChange(value, "fromDish")}
                placeholder='Select Dish'
              />
            </div>
            <div className={`flex flex-column mr-24 ${styles.multiSelect}`}>
              <SingleSelectWithRadio
                label="To Dish"
                options={toDishFilteredOptions}
                value={toDishOption}
                disabled={!canSelectToDish}
                onApply={(value:any) => handleChange(value, "toDish")}
                placeholder='Select Dish'
              />
            </div>
            <div className={`flex flex-column ${styles.multiSelect}`}>
              <SingleSelectWithRadio
                label="Reason"
                options={reasonsOptions}
                value={reasonOption}
                disabled={!canSelectReason}
                onApply={(value: any) => handleChange(value, "reason")}
                placeholder='Select Reason'
              />
            </div>
          </div>
          <Button onClick={handleSubmit} disabled={isButtonDisabled()} className={`primary-btn ${styles.primaryBtn}`}>
            Go <IconArrowRight />
          </Button>
        </div>
      </FormControl>
    </LocalizationProvider>
  );
};

export default FilterData;
